/* This file was auto generated by "icon-optimizer" */

import { DEV } from 'esm-env';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  'm8 20.4-6.7-6.6 1.4-1.5 3.9 3.9c.8.8 2 .8 2.8 0L20.7 4.9l1.4 1.4L8 20.4Z',
  DEV ? 'CheckIcon' : '',
  '',
  false,
);
